<template>

  <section class="clientele section" id="clients">
    <div class="container">
      <div class="row">

        <div class="heading col-12">
          <h3 class="title">Our amazing clients</h3>

            <h4 class="legend">From SaaS and corporate software, to mobile apps and websites, we build digital experiences that our clients love.</h4>

            <h4 class="legend">We work as one team with them in an iterative design and development process.</h4>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row">

      <div class="client-logo-band">

        <div class="client-logo-wrap">
          <img alt="Casino Colchagua" class="client-logo-image" style='transform: scale(0.7);' src="/static/img/clients-logos/casino-colchagua.svg">
        </div>
        <div class="client-logo-wrap">
          <img alt="Alma Cruz" class="client-logo-image" src="/static/img/clients-logos/almacruz.svg">
        </div>
        <div class="client-logo-wrap">
          <img alt="Hotel Santa Cruz" class="client-logo-image" src="/static/img/clients-logos/hotel-santa-cruz.svg">
        </div>
        <div class="client-logo-wrap">
          <img alt="Viña Santa Cruz" class="client-logo-image" src="/static/img/clients-logos/vina-santa-cruz.svg">
        </div>
        <div class="client-logo-wrap">
          <img alt="Museo de Colchagua" class="client-logo-image" src="/static/img/clients-logos/museo-colchagua.svg">
        </div>
        <div class="client-logo-wrap">
          <img alt="Viña Montes" class="client-logo-image" src="/static/img/clients-logos/montes-wines.svg">
        </div>

        <div class="client-logo-wrap">
          <img alt="Banco Security" class="client-logo-image" src="/static/img/clients-logos/banco-security.svg">
        </div>

<!--         <div class="client-logo-wrap">
          <img alt="Pasadena Pino Fest" class="client-logo-image" src="/static/img/clients-logos/pasadena-pinot-fest.svg">
        </div> -->

        <div class="client-logo-wrap">
          <img alt="SP Digital.cl" class="client-logo-image" src="/static/img/clients-logos/sp-digital.svg">
        </div>

<!--         <div class="client-logo-wrap">
          <img alt="Entel" style='transform: scale(0.5);' class="client-logo-image" src="/static/img/clients-logos/entel.svg">
        </div> -->
<!--         <div class="client-logo-wrap">
          <img alt="Falabella" style='transform: scale(0.5);' class="client-logo-image" src="/static/img/clients-logos/falabella.svg">
        </div> -->

<!--         <div class="client-logo-wrap">
          <img alt="Telefónica Chile" class="client-logo-image" src="/static/img/clients-logos/telefonica.svg">
        </div> -->

        <div class="client-logo-wrap">
          <img alt="Ripley" class="client-logo-image" src="/static/img/clients-logos/ripley.svg">
        </div>

        <div class="client-logo-wrap">
          <img alt="Canal 13" class="client-logo-image" style='transform: scale(0.5)' src="/static/img/clients-logos/canal-13.svg">
        </div>

        <div class="client-logo-wrap">
          <img alt="Dunkin' Donuts" class="client-logo-image" src="/static/img/clients-logos/dunkin-donuts.svg">
        </div>

        <div class="client-logo-wrap">
          <img alt="BCP" class="client-logo-image" src="/static/img/clients-logos/bcp.svg">
        </div>

        <div class="client-logo-wrap">
          <img alt="Universidad Diego Portales" class="client-logo-image" src="/static/img/clients-logos/udp.svg">
        </div>


      </div>


      </div>
      </div>


  </section>

</template>


<script>
export default {
  name: 'Clients',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.clientele {
    background-color: white;
    text-align: center;
}

.clientele .heading .title {
  color: #131313;
}

.clientele .heading .legend {
  color: #270604;
}

.clientele h1 {
    margin: 0 auto;
    width: 100%;
    max-width: 840px
}
@media (max-width: 479px) {
    .clientele h1 {
        padding-bottom: 30px
    }
}
.clientele h2 {
    color: #717171;
}
.client-logo-image {
    width: 160px
}
.clientele ul {
    width: 70%;
    margin: 0 auto;
    text-align: center;
    line-height: 1.5
}
@media (max-width: 479px) {
    .clientele ul {
        width: 100%
    }
}
.clientele ul li {
    display: inline;
    font-size: 1.3em
}
@media (max-width: 767px) {
    .clientele ul li {
        font-size: 1.1em
    }
}
@media (max-width: 479px) {
    .clientele ul li {
        font-size: 1em
    }
}

.client-logo-band {
display: inline-flex;
justify-content: center;
align-content: center;
flex-direction: row;
flex-wrap:wrap;
padding-top:4vw;
}

.client-logo-wrap {
  display: flex;
  height: 150px;
  justify-content: center;
  align-items: center;
  margin: 0 2em;
}

@media all and (max-width: 768px) {
  .client-logo-wrap {
    margin: 0 .5em;
  }
  .client-logo-image {
    width: 100px;
  }
}

.client-logo-wrap img {
  opacity: 0.7;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  transition: all 250ms ease-in-out;
}


.client-logo-wrap img:hover {
  opacity: 1;
  -webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
  filter: grayscale(0%);
}


</style>



// WEBPACK FOOTER //
// src/components/Clients.vue